// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"c6d7d83f","495":"8f67df46","528":"a97dd92a","707":"8f67df46"}[chunkId] + ".chunk.css";
};